import React, { useState } from 'react';
import { 
  Building2, User, MapPin, Phone, Mail, Search, Plus, Edit, Trash2, 
  ChevronLeft, ChevronRight, Filter, X, Save, Clock, Award, IdCard,
  Users, Settings, Eye, UserPlus, Building
} from 'lucide-react';

const PharmacyManagementUnified = () => {
  const [activeTab, setActiveTab] = useState('pharmacies'); // 'pharmacies' | 'pharmacists'
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null); // 'add' | 'edit' | 'assign'
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({
    city: 'all',
    status: 'all',
    pharmacy: 'all'
  });

  const itemsPerPage = 10;

  // DATA
  const pharmacies = [
    {
      id: 1,
      name: 'Pharmacie Dakar Centre',
      city: 'Dakar',
      address: 'Avenue Léopold Sédar Senghor',
      phone: '+221 77 123 45 67',
      email: 'contact@pharmaciedakar.sn',
      pharmacist: 'Dr. Fatou Ndiaye',
      pharmacistId: 1,
      openingHours: '8h - 20h',
      status: 'active',
      staffCount: 5
    },
    {
      id: 2,
      name: 'Pharmacie Thies Nord',
      city: 'Thies',
      address: 'Route Nationale 2',
      phone: '+221 77 234 56 78',
      email: 'pharmaciethies@gmail.com',
      pharmacist: 'Dr. Amadou Diop',
      pharmacistId: 2,
      openingHours: '8h - 21h',
      status: 'active',
      staffCount: 3
    },
    {
      id: 3,
      name: 'Pharmacie Mbour',
      city: 'Mbour',
      address: 'Centre Ville Mbour',
      phone: '+221 77 345 67 89',
      email: 'pharma.mbour@orange.sn',
      pharmacist: 'Non assigné',
      pharmacistId: null,
      openingHours: '7h30 - 22h',
      status: 'active',
      staffCount: 2
    },
  ];

  const pharmacists = [
    {
      id: 1,
      firstName: 'Fatou',
      lastName: 'Ndiaye',
      email: 'f.ndiaye@pharmacie.sn',
      phone: '+221 77 123 45 67',
      specialization: 'Pharmacie Clinique',
      licenseNumber: 'SN-PHR-2015-001234',
      pharmacy: 'Pharmacie Dakar Centre',
      pharmacyId: 1,
      status: 'active',
      hireDate: '2015-06-01'
    },
    {
      id: 2,
      firstName: 'Amadou',
      lastName: 'Diop',
      email: 'a.diop@pharmacie.sn',
      phone: '+221 77 234 56 78',
      specialization: 'Pharmacie Hospitalière',
      licenseNumber: 'SN-PHR-2018-002345',
      pharmacy: 'Pharmacie Thies Nord',
      pharmacyId: 2,
      status: 'active',
      hireDate: '2018-09-15'
    },
    {
      id: 3,
      firstName: 'Aïssa',
      lastName: 'Fall',
      email: 'a.fall@pharmacie.sn',
      phone: '+221 77 345 67 89',
      specialization: 'Pharmacie Communautaire',
      licenseNumber: 'SN-PHR-2016-003456',
      pharmacy: 'Non assigné',
      pharmacyId: null,
      status: 'available',
      hireDate: '2016-03-20'
    },
  ];

  const cities = ['Dakar', 'Thies', 'Mbour', 'Saint-Louis', 'Rufisque'];
  const specializations = ['Pharmacie Clinique', 'Pharmacie Hospitalière', 'Pharmacie Communautaire', 'Pharmacologie'];

  // FILTERING
  const getFilteredData = () => {
    const data = activeTab === 'pharmacies' ? pharmacies : pharmacists;
    
    return data.filter(item => {
      const matchesSearch = activeTab === 'pharmacies' 
        ? item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.city.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.pharmacist.toLowerCase().includes(searchTerm.toLowerCase())
        : `${item.firstName} ${item.lastName}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.pharmacy.toLowerCase().includes(searchTerm.toLowerCase());

      const matchesCity = filters.city === 'all' || item.city === filters.city;
      const matchesStatus = filters.status === 'all' || item.status === filters.status;
      const matchesPharmacy = activeTab === 'pharmacists' && 
        (filters.pharmacy === 'all' || item.pharmacy === filters.pharmacy);

      return matchesSearch && matchesCity && matchesStatus && 
        (activeTab === 'pharmacies' || matchesPharmacy);
    });
  };

  const filteredData = getFilteredData();
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // MODALS
  const openAddModal = () => {
    setModalType('add');
    setSelectedItem(null);
    setShowModal(true);
  };

  const openEditModal = (item) => {
    setModalType('edit');
    setSelectedItem(item);
    setShowModal(true);
  };

  const openAssignModal = (item) => {
    setModalType('assign');
    setSelectedItem(item);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedItem(null);
    setModalType(null);
  };

  const handleDelete = (id) => {
    if (window.confirm(`Êtes-vous sûr de vouloir supprimer cet élément ?`)) {
      alert('Suppression effectuée (simulation)');
    }
  };

  const getStatusBadge = (status) => {
    const badges = {
      active: { bg: 'bg-emerald-100', text: 'text-emerald-700', label: 'Actif', border: 'border-emerald-200' },
      available: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Disponible', border: 'border-blue-200' },
      on_leave: { bg: 'bg-orange-100', text: 'text-orange-700', label: 'En congé', border: 'border-orange-200' },
      inactive: { bg: 'bg-gray-100', text: 'text-gray-700', label: 'Inactif', border: 'border-gray-200' }
    };
    return badges[status] || badges.active;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Background Pattern */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none opacity-30">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, rgb(209, 213, 219) 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <main className="relative z-10 p-4 md:p-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-4xl md:text-5xl font-black text-gray-800 mb-2">
            Gestion du Réseau
          </h1>
          <p className="text-gray-600 text-lg">Pharmacies et Pharmaciens</p>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
          <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">Pharmacies</p>
                <p className="text-3xl font-bold text-gray-800">{pharmacies.length}</p>
              </div>
              <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center">
                <Building2 className="text-white" size={24} />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">Pharmaciens</p>
                <p className="text-3xl font-bold text-gray-800">{pharmacists.length}</p>
              </div>
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center">
                <Users className="text-white" size={24} />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">Actifs</p>
                <p className="text-3xl font-bold text-emerald-600">
                  {pharmacists.filter(p => p.status === 'active').length}
                </p>
              </div>
              <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-xl flex items-center justify-center">
                <User className="text-white" size={24} />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">Villes</p>
                <p className="text-3xl font-bold text-gray-800">{cities.length}</p>
              </div>
              <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl flex items-center justify-center">
                <MapPin className="text-white" size={24} />
              </div>
            </div>
          </div>
        </div>

        {/* Main Content Card */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
          {/* Tabs */}
          <div className="border-b border-gray-200 bg-gray-50">
            <div className="flex">
              <button
                onClick={() => { setActiveTab('pharmacies'); setCurrentPage(1); }}
                className={`flex items-center space-x-2 px-6 py-4 font-bold transition-all ${
                  activeTab === 'pharmacies'
                    ? 'bg-white text-emerald-600 border-b-2 border-emerald-600'
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                <Building2 size={20} />
                <span>Pharmacies</span>
                <span className="px-2 py-0.5 bg-emerald-100 text-emerald-700 rounded-full text-xs font-bold">
                  {pharmacies.length}
                </span>
              </button>
              <button
                onClick={() => { setActiveTab('pharmacists'); setCurrentPage(1); }}
                className={`flex items-center space-x-2 px-6 py-4 font-bold transition-all ${
                  activeTab === 'pharmacists'
                    ? 'bg-white text-blue-600 border-b-2 border-blue-600'
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                <Users size={20} />
                <span>Pharmaciens</span>
                <span className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded-full text-xs font-bold">
                  {pharmacists.length}
                </span>
              </button>
            </div>
          </div>

          {/* Filters Bar */}
          <div className="p-6 border-b border-gray-200 bg-gray-50">
            <div className="flex flex-col md:flex-row gap-4 items-start md:items-center justify-between">
              {/* Search */}
              <div className="flex-1 w-full md:w-auto">
                <div className="relative">
                  <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                  <input
                    type="text"
                    placeholder={`Rechercher ${activeTab === 'pharmacies' ? 'une pharmacie' : 'un pharmacien'}...`}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
              </div>

              {/* Filters */}
              <div className="flex gap-3 w-full md:w-auto flex-wrap">
                <select
                  value={filters.city}
                  onChange={(e) => setFilters({...filters, city: e.target.value})}
                  className="px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                >
                  <option value="all">🌍 Toutes les villes</option>
                  {cities.map(city => (
                    <option key={city} value={city}>{city}</option>
                  ))}
                </select>

                <select
                  value={filters.status}
                  onChange={(e) => setFilters({...filters, status: e.target.value})}
                  className="px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                >
                  <option value="all">Tous les statuts</option>
                  <option value="active">Actif</option>
                  <option value="available">Disponible</option>
                  <option value="on_leave">En congé</option>
                  <option value="inactive">Inactif</option>
                </select>

                <button
                  onClick={openAddModal}
                  className={`flex items-center space-x-2 px-6 py-3 text-white rounded-xl hover:shadow-xl transition-all font-bold whitespace-nowrap ${
                    activeTab === 'pharmacies'
                      ? 'bg-gradient-to-r from-emerald-600 to-teal-600'
                      : 'bg-gradient-to-r from-blue-600 to-blue-700'
                  }`}
                >
                  <Plus size={20} />
                  <span>Ajouter</span>
                </button>
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  {activeTab === 'pharmacies' ? (
                    <>
                      <th className="px-6 py-4 text-left text-xs font-bold text-gray-600 uppercase">Pharmacie</th>
                      <th className="px-6 py-4 text-left text-xs font-bold text-gray-600 uppercase">Ville</th>
                      <th className="px-6 py-4 text-left text-xs font-bold text-gray-600 uppercase">Pharmacien</th>
                      <th className="px-6 py-4 text-left text-xs font-bold text-gray-600 uppercase">Contact</th>
                      {/* <th className="px-6 py-4 text-left text-xs font-bold text-gray-600 uppercase">Personnel</th> */}
                      <th className="px-6 py-4 text-left text-xs font-bold text-gray-600 uppercase">Statut</th>
                      <th className="px-6 py-4 text-right text-xs font-bold text-gray-600 uppercase">Actions</th>
                    </>
                  ) : (
                    <>
                      <th className="px-6 py-4 text-left text-xs font-bold text-gray-600 uppercase">Pharmacien</th>
                      <th className="px-6 py-4 text-left text-xs font-bold text-gray-600 uppercase">Spécialisation</th>
                      <th className="px-6 py-4 text-left text-xs font-bold text-gray-600 uppercase">N° Licence</th>
                      <th className="px-6 py-4 text-left text-xs font-bold text-gray-600 uppercase">Pharmacie</th>
                      <th className="px-6 py-4 text-left text-xs font-bold text-gray-600 uppercase">Contact</th>
                      <th className="px-6 py-4 text-left text-xs font-bold text-gray-600 uppercase">Statut</th>
                      <th className="px-6 py-4 text-right text-xs font-bold text-gray-600 uppercase">Actions</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {paginatedData.map((item) => {
                  const badge = getStatusBadge(item.status);
                  
                  return activeTab === 'pharmacies' ? (
                    <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                      <td className="px-6 py-4">
                        <div className="flex items-center space-x-3">
                          <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                            <Building2 className="text-white" size={20} />
                          </div>
                          <div>
                            <p className="font-bold text-gray-900">{item.name}</p>
                            <p className="text-sm text-gray-500">{item.address}</p>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className="flex items-center space-x-1 text-gray-700">
                          <MapPin size={16} className="text-gray-400" />
                          <span className="font-medium">{item.city}</span>
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center space-x-2">
                          {item.pharmacistId ? (
                            <>
                              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                                <User size={16} className="text-blue-600" />
                              </div>
                              <span className="text-sm font-medium text-gray-900">{item.pharmacist}</span>
                            </>
                          ) : (
                            <button
                              onClick={() => openAssignModal(item)}
                              className="flex items-center space-x-1 text-blue-600 hover:text-blue-700 text-sm font-semibold"
                            >
                              <UserPlus size={16} />
                              <span>Assigner</span>
                            </button>
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="space-y-1">
                          <a href={`tel:${item.phone}`} className="flex items-center space-x-1 text-sm text-gray-600 hover:text-blue-600">
                            <Phone size={14} />
                            <span>{item.phone}</span>
                          </a>
                          <a href={`mailto:${item.email}`} className="flex items-center space-x-1 text-sm text-gray-600 hover:text-blue-600">
                            <Mail size={14} />
                            <span className="truncate max-w-[200px]">{item.email}</span>
                          </a>
                        </div>
                      </td>
                      {/* <td className="px-6 py-4">
                        <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-sm font-bold">
                          {item.staffCount} pers.
                        </span>
                      </td> */}
                      <td className="px-6 py-4">
                        <span className={`px-3 py-1 ${badge.bg} ${badge.text} rounded-full text-xs font-bold border ${badge.border}`}>
                          {badge.label}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center justify-end space-x-2">
                          <button
                            onClick={() => openEditModal(item)}
                            className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-all"
                            title="Modifier"
                          >
                            <Edit size={18} />
                          </button>
                          <button
                            onClick={() => handleDelete(item.id)}
                            className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-all"
                            title="Supprimer"
                          >
                            <Trash2 size={18} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                      <td className="px-6 py-4">
                        <div className="flex items-center space-x-3">
                          <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                            <User className="text-white" size={20} />
                          </div>
                          <div>
                            <p className="font-bold text-gray-900">Dr. {item.firstName} {item.lastName}</p>
                            <p className="text-sm text-gray-500">{item.email}</p>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className="flex items-center space-x-1 text-sm">
                          <Award size={16} className="text-gray-400" />
                          <span className="font-medium text-gray-700">{item.specialization}</span>
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <span className="font-mono text-sm text-gray-600">{item.licenseNumber}</span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center space-x-2">
                          {item.pharmacyId ? (
                            <>
                              <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center">
                                <Building size={16} className="text-emerald-600" />
                              </div>
                              <span className="text-sm font-medium text-gray-900">{item.pharmacy}</span>
                            </>
                          ) : (
                            <span className="text-sm text-gray-400 italic">Non assigné</span>
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <a href={`tel:${item.phone}`} className="text-sm text-gray-600 hover:text-blue-600">
                          {item.phone}
                        </a>
                      </td>
                      <td className="px-6 py-4">
                        <span className={`px-3 py-1 ${badge.bg} ${badge.text} rounded-full text-xs font-bold border ${badge.border}`}>
                          {badge.label}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center justify-end space-x-2">
                          <button
                            onClick={() => openEditModal(item)}
                            className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-all"
                            title="Modifier"
                          >
                            <Edit size={18} />
                          </button>
                          <button
                            onClick={() => handleDelete(item.id)}
                            className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-all"
                            title="Supprimer"
                          >
                            <Trash2 size={18} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="px-6 py-4 border-t border-gray-200 bg-gray-50 flex items-center justify-between">
              <div className="text-sm text-gray-600">
                Affichage de {((currentPage - 1) * itemsPerPage) + 1} à{' '}
                {Math.min(currentPage * itemsPerPage, filteredData.length)} sur{' '}
                {filteredData.length} résultats
              </div>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                  disabled={currentPage === 1}
                  className="p-2 border border-gray-300 rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                >
                  <ChevronLeft size={20} />
                </button>
                
                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i + 1}
                    onClick={() => setCurrentPage(i + 1)}
                    className={`px-4 py-2 rounded-lg font-bold transition-all ${
                      currentPage === i + 1
                        ? 'bg-blue-600 text-white'
                        : 'border border-gray-300 hover:bg-gray-100'
                    }`}
                  >
                    {i + 1}
                  </button>
                ))}

                <button
                  onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                  disabled={currentPage === totalPages}
                  className="p-2 border border-gray-300 rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                >
                  <ChevronRight size={20} />
                </button>
              </div>
            </div>
          )}

          {/* Empty State */}
          {filteredData.length === 0 && (
            <div className="text-center py-12">
              {activeTab === 'pharmacies' ? (
                <Building2 size={64} className="mx-auto text-gray-300 mb-4" />
              ) : (
                <Users size={64} className="mx-auto text-gray-300 mb-4" />
              )}
              <p className="text-gray-500 text-lg">Aucun résultat trouvé</p>
            </div>
          )}
        </div>
      </main>

      {/* Modal - Add/Edit/Assign */}
      {showModal && (
        <ModalComponent 
          modalType={modalType}
          activeTab={activeTab}
          selectedItem={selectedItem}
          pharmacies={pharmacies}
          pharmacists={pharmacists}
          cities={cities}
          specializations={specializations}
          onClose={closeModal}
        />
      )}
    </div>
  );
};

// Modal Component
const ModalComponent = ({ modalType, activeTab, selectedItem, pharmacies, pharmacists, cities, specializations, onClose }) => {
  const [searchPharmacy, setSearchPharmacy] = useState('');
  const [searchPharmacist, setSearchPharmacist] = useState('');
  const [selectedAssignment, setSelectedAssignment] = useState(null);
  
  // Form data
  const [formData, setFormData] = useState(
    selectedItem ? { ...selectedItem } : activeTab === 'pharmacies' 
      ? {
          name: '',
          city: '',
          address: '',
          phone: '',
          email: '',
          openingHours: '',
          status: 'active'
        }
      : {
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          specialization: '',
          licenseNumber: '',
          status: 'available'
        }
  );

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const filteredPharmacies = pharmacies.filter(p => 
    p.name.toLowerCase().includes(searchPharmacy.toLowerCase()) ||
    p.city.toLowerCase().includes(searchPharmacy.toLowerCase())
  );

  const filteredPharmacists = pharmacists.filter(p => 
    `${p.firstName} ${p.lastName}`.toLowerCase().includes(searchPharmacist.toLowerCase()) ||
    p.specialization.toLowerCase().includes(searchPharmacist.toLowerCase())
  );

  const handleSubmit = () => {
    if (modalType === 'assign') {
      if (!selectedAssignment) {
        alert('Veuillez sélectionner un pharmacien à assigner');
        return;
      }
      // Assignation : Pharmacie -> Pharmacien
      alert(
        `✅ Dr. ${selectedAssignment.firstName} ${selectedAssignment.lastName} est maintenant pharmacien responsable de ${selectedItem.name}`
      );
    } else {
      alert('Sauvegarde effectuée (simulation)');
    }
    onClose();
  };

  // ASSIGN MODAL
  if (modalType === 'assign') {
    // L'assignation se fait uniquement depuis les pharmacies vers les pharmaciens
    
    return (
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-3xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
          <div className="sticky top-0 bg-gradient-to-r from-emerald-600 to-teal-600 px-6 py-4 flex items-center justify-between rounded-t-3xl">
            <h2 className="text-2xl font-black text-white">
              👨‍⚕️ Assigner un pharmacien responsable
            </h2>
            <button onClick={onClose} className="p-2 hover:bg-white/20 rounded-xl transition-all text-white">
              <X size={24} />
            </button>
          </div>

          <div className="p-6">
            {/* Current Pharmacy */}
            <div className="mb-6 p-4 bg-emerald-50 rounded-xl border-2 border-emerald-200">
              <p className="text-sm text-emerald-600 font-bold mb-2">
                🏥 Pharmacie
              </p>
              <p className="font-black text-gray-900 text-lg">
                {selectedItem.name}
              </p>
              <p className="text-sm text-gray-600 mt-1">
                {selectedItem.address}, {selectedItem.city}
              </p>
            </div>

            {/* Selected Pharmacist Preview */}
            {selectedAssignment && (
              <div className="mb-4 p-4 bg-blue-50 rounded-xl border-2 border-blue-200">
                <p className="text-sm text-blue-600 font-bold mb-2">
                  ✓ Pharmacien sélectionné
                </p>
                <p className="font-black text-gray-900">
                  Dr. {selectedAssignment.firstName} {selectedAssignment.lastName}
                </p>
                <p className="text-sm text-gray-600">
                  {selectedAssignment.specialization}
                </p>
              </div>
            )}

            {/* Search */}
            <div className="mb-4">
              <label className="block text-sm font-bold text-gray-700 mb-2">
                Rechercher un pharmacien
              </label>
              <div className="relative">
                <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                <input
                  type="text"
                  placeholder="Rechercher par nom, spécialisation..."
                  value={searchPharmacist}
                  onChange={(e) => setSearchPharmacist(e.target.value)}
                  className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-emerald-500"
                />
              </div>
            </div>

            {/* Pharmacists List */}
            <div className="max-h-96 overflow-y-auto space-y-2 mb-6">
              {filteredPharmacists.length === 0 ? (
                <div className="text-center py-8">
                  <User size={48} className="mx-auto text-gray-300 mb-2" />
                  <p className="text-gray-500">Aucun pharmacien trouvé</p>
                </div>
              ) : (
                filteredPharmacists.map((pharmacist) => (
                  <button
                    key={pharmacist.id}
                    onClick={() => setSelectedAssignment(pharmacist)}
                    className={`w-full p-4 border-2 rounded-xl transition-all text-left ${
                      selectedAssignment?.id === pharmacist.id
                        ? 'border-blue-500 bg-blue-50'
                        : 'border-gray-200 hover:border-emerald-500 hover:bg-emerald-50'
                    }`}
                  >
                    <div className="flex items-center space-x-3">
                      <div className={`w-12 h-12 ${
                        selectedAssignment?.id === pharmacist.id
                          ? 'bg-gradient-to-br from-blue-500 to-blue-600'
                          : 'bg-gradient-to-br from-gray-400 to-gray-500'
                      } rounded-xl flex items-center justify-center flex-shrink-0`}>
                        <User className="text-white" size={24} />
                      </div>
                      <div className="flex-1">
                        <p className="font-bold text-gray-900">
                          Dr. {pharmacist.firstName} {pharmacist.lastName}
                        </p>
                        <p className="text-sm text-gray-500">
                          {pharmacist.specialization}
                        </p>
                        <div className="flex items-center space-x-3 mt-1">
                          <span className="text-xs text-gray-400 font-mono">
                            {pharmacist.licenseNumber}
                          </span>
                          {pharmacist.pharmacyId ? (
                            <span className="px-2 py-0.5 bg-orange-100 text-orange-700 rounded-full text-xs font-bold">
                              Déjà assigné
                            </span>
                          ) : (
                            <span className="px-2 py-0.5 bg-emerald-100 text-emerald-700 rounded-full text-xs font-bold">
                              Disponible
                            </span>
                          )}
                        </div>
                      </div>
                      {selectedAssignment?.id === pharmacist.id && (
                        <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
                          <span className="text-white font-bold text-lg">✓</span>
                        </div>
                      )}
                    </div>
                  </button>
                ))
              )}
            </div>

            {/* Actions */}
            <div className="flex space-x-3 border-t border-gray-200 pt-4">
              <button
                onClick={onClose}
                className="flex-1 px-6 py-3 bg-gray-100 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-200 transition-all font-bold"
              >
                Annuler
              </button>
              <button
                onClick={handleSubmit}
                disabled={!selectedAssignment}
                className="flex-1 px-6 py-3 bg-gradient-to-r from-emerald-600 to-teal-600 text-white rounded-xl hover:shadow-xl transition-all font-bold disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <Save size={20} className="inline mr-2" />
                Assigner le pharmacien
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // ADD/EDIT MODAL - PHARMACIES
  if (activeTab === 'pharmacies') {
    return (
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-3xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
          <div className="sticky top-0 bg-gradient-to-r from-emerald-600 to-teal-600 px-6 py-4 flex items-center justify-between rounded-t-3xl z-10">
            <h2 className="text-2xl font-black text-white">
              {modalType === 'add' ? '➕ Nouvelle pharmacie' : '✏️ Modifier la pharmacie'}
            </h2>
            <button onClick={onClose} className="p-2 hover:bg-white/20 rounded-xl transition-all text-white">
              <X size={24} />
            </button>
          </div>

          <div className="p-6">
            <div className="space-y-6">
              {/* Basic Info */}
              <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
                <h3 className="font-bold text-gray-800 mb-4 flex items-center">
                  <Building2 size={20} className="mr-2" />
                  Informations générales
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">
                      Nom de la pharmacie *
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-emerald-500"
                      placeholder="Pharmacie..."
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">
                      Ville *
                    </label>
                    <select
                      name="city"
                      value={formData.city}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-emerald-500"
                    >
                      <option value="">Sélectionner...</option>
                      {cities.map(city => (
                        <option key={city} value={city}>{city}</option>
                      ))}
                    </select>
                  </div>

                  <div className="md:col-span-2">
                    <label className="block text-sm font-bold text-gray-700 mb-2">
                      Adresse complète *
                    </label>
                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-emerald-500"
                      placeholder="Avenue..."
                    />
                  </div>
                </div>
              </div>

              {/* Contact */}
              <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
                <h3 className="font-bold text-gray-800 mb-4 flex items-center">
                  <Phone size={20} className="mr-2" />
                  Contact
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">
                      Téléphone *
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-emerald-500"
                      placeholder="+221 77 123 45 67"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">
                      Email *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-emerald-500"
                      placeholder="contact@pharmacie.sn"
                    />
                  </div>
                </div>
              </div>

              {/* Operations */}
              <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
                <h3 className="font-bold text-gray-800 mb-4 flex items-center">
                  <Clock size={20} className="mr-2" />
                  Informations opérationnelles
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">
                      Horaires d'ouverture
                    </label>
                    <input
                      type="text"
                      name="openingHours"
                      value={formData.openingHours}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-emerald-500"
                      placeholder="8h - 20h"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">
                      Statut *
                    </label>
                    <select
                      name="status"
                      value={formData.status}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-emerald-500"
                    >
                      <option value="active">Actif</option>
                      <option value="inactive">Inactif</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex space-x-3 pt-6 border-t border-gray-200 mt-6">
              <button
                onClick={onClose}
                className="flex-1 px-6 py-3 bg-gray-100 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-200 transition-all font-bold"
              >
                Annuler
              </button>
              <button
                onClick={handleSubmit}
                className="flex-1 px-6 py-3 bg-gradient-to-r from-emerald-600 to-teal-600 text-white rounded-xl hover:shadow-xl transition-all font-bold"
              >
                <Save size={20} className="inline mr-2" />
                {modalType === 'add' ? 'Enregistrer' : 'Mettre à jour'}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // ADD/EDIT MODAL - PHARMACISTS
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-3xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-4 flex items-center justify-between rounded-t-3xl z-10">
          <h2 className="text-2xl font-black text-white">
            {modalType === 'add' ? '➕ Nouveau pharmacien' : '✏️ Modifier le pharmacien'}
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-white/20 rounded-xl transition-all text-white">
            <X size={24} />
          </button>
        </div>

        <div className="p-6">
          <div className="space-y-6">
            {/* Personal Info */}
            <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
              <h3 className="font-bold text-gray-800 mb-4 flex items-center">
                <User size={20} className="mr-2" />
                Informations personnelles
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">
                    Prénom *
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Prénom"
                  />
                </div>

                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">
                    Nom *
                  </label>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Nom"
                  />
                </div>
              </div>
            </div>

            {/* Contact */}
            <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
              <h3 className="font-bold text-gray-800 mb-4 flex items-center">
                <Phone size={20} className="mr-2" />
                Contact
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="email@pharmacie.sn"
                  />
                </div>

                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">
                    Téléphone *
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="+221 77 123 45 67"
                  />
                </div>
              </div>
            </div>

            {/* Professional Info */}
            <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
              <h3 className="font-bold text-gray-800 mb-4 flex items-center">
                <Award size={20} className="mr-2" />
                Informations professionnelles
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">
                    Numéro de licence *
                  </label>
                  <input
                    type="text"
                    name="licenseNumber"
                    value={formData.licenseNumber}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="SN-PHR-2024-XXXXXX"
                  />
                </div>

                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">
                    Spécialisation *
                  </label>
                  <select
                    name="specialization"
                    value={formData.specialization}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">Sélectionner...</option>
                    {specializations.map(spec => (
                      <option key={spec} value={spec}>{spec}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">
                    Statut *
                  </label>
                  <select
                    name="status"
                    value={formData.status}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="active">Actif</option>
                    <option value="available">Disponible</option>
                    <option value="on_leave">En congé</option>
                    <option value="inactive">Inactif</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="flex space-x-3 pt-6 border-t border-gray-200 mt-6">
            <button
              onClick={onClose}
              className="flex-1 px-6 py-3 bg-gray-100 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-200 transition-all font-bold"
            >
              Annuler
            </button>
            <button
              onClick={handleSubmit}
              className="flex-1 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl hover:shadow-xl transition-all font-bold"
            >
              <Save size={20} className="inline mr-2" />
              {modalType === 'add' ? 'Enregistrer' : 'Mettre à jour'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PharmacyManagementUnified;